import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
import { Update } from './types';

interface UpdateCardProps {
  update: Update;
  index: number;
}

export default function UpdateCard({ update, index }: UpdateCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="flex gap-4 bg-green-50 rounded-xl p-4 hover:bg-green-100 transition-colors"
    >
      <img
        src={update.image}
        alt={update.title}
        className="w-24 h-24 object-cover rounded-lg flex-shrink-0"
      />
      <div>
        <div className="flex items-center text-sm text-green-600 mb-1">
          <Calendar className="h-4 w-4 mr-1" />
          {update.date}
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{update.title}</h3>
        <p className="text-sm text-gray-600 line-clamp-2">{update.description}</p>
      </div>
    </motion.div>
  );
}